// Capture this script's own URL so the lazy component loader (below) can build sibling /assets/ URLs.
const _globalScriptSrc = (document.currentScript && document.currentScript.src) || '';

// Cache the focusable selector string (avoids re-parsing the complex selector each call)
const _FOCUSABLE_SEL = "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe";

function getFocusableElements(container) {
  return Array.from(container.querySelectorAll(_FOCUSABLE_SEL));
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  // Skip summaries inside menu-drawer - they're handled by MenuDrawer class
  const isInMenuDrawer = summary.closest('header-drawer, menu-drawer');
  if (isInMenuDrawer) return;

  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// :focus-visible polyfill removed — all supported browsers implement it natively

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.tryInitialize();
    if (!this.initialized) {
      if (this && this.nodeType === Node.ELEMENT_NODE) {
        this.observer = new MutationObserver(() => this.tryInitialize());
        this.observer.observe(this, { childList: true, subtree: true });
      }
    }
  }

  tryInitialize() {
    this.input = this.querySelector('input');
    if (!this.input) return;
    // Remove observer after initialization
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    this.initialized = true;
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    if (!this.input) return;

    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {

    if (this.initialized) {
      return;
    }

    this.tryInitialize();
    if (!this.initialized) {
      // Check if this is a valid Node before observing
      if (this && this.nodeType === Node.ELEMENT_NODE) {
        this.observer = new MutationObserver(() => {
          this.tryInitialize();
        });
        this.observer.observe(this, { childList: true, subtree: true });
      }
    }
  }

  tryInitialize() {

    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) {
      return;
    }


    // Remove observer after initialization
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();

    // Content observer deferred — only activated when menu opens (see openMenuDrawer).
    // Avoids MutationObserver overhead during initial page load.
    this.lastSummaryCount = this.querySelectorAll('summary').length;

    this.initialized = true;

  }

  bindEvents() {
    // Query for summaries in the entire menu drawer, including nested forms
    const allSummaries = this.querySelectorAll('summary');
    const mobileFacets = this.querySelectorAll('.mobile-facets__details');


    allSummaries.forEach((summary, index) => {
      const detailsElement = summary.parentNode;
      const isMainToggle = detailsElement === this.mainDetailsToggle;
      const isMobileFacet = detailsElement.classList.contains('mobile-facets__details');


      if (isMainToggle) {
        // Main drawer toggle - handle it
        summary.addEventListener('click', this.onSummaryClick.bind(this));
      } else if (isMobileFacet) {
        // Mobile filter submenu - manually toggle the open attribute
        // Check if already bound to avoid duplicate listeners
        if (summary.dataset.mobileFacetBound === 'true') {
          return;
        }
        summary.dataset.mobileFacetBound = 'true';

        // Toggle open state via click handler only — no MutationObserver needed.
        // We use capture phase + preventDefault to fully control the <details> toggle.
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          const isOpen = detailsElement.hasAttribute('open');

          if (isOpen) {
            detailsElement.removeAttribute('open');
            summary.setAttribute('aria-expanded', false);
            detailsElement.classList.remove('menu-opening');
            const parentMenuElement = detailsElement.closest('.has-submenu');
            parentMenuElement && parentMenuElement.classList.remove('submenu-open');
          } else {
            detailsElement.setAttribute('open', '');
            summary.setAttribute('aria-expanded', true);
            detailsElement.classList.add('menu-opening');

            const parentMenuElement = detailsElement.closest('.has-submenu');
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

            if (parentMenuElement) {
              parentMenuElement.classList.add('submenu-open');
            }

            requestAnimationFrame(() => {
              function addTrapFocus() {
                trapFocus(summary.nextElementSibling, detailsElement.querySelector('button'));
                summary.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
              }

              !reducedMotion || reducedMotion.matches
                ? addTrapFocus()
                : summary.nextElementSibling.addEventListener('transitionend', addTrapFocus);
            });
          }
        }, true);
      } else {
        // Other submenus - use the standard handler
        summary.addEventListener('click', this.onSummaryClick.bind(this));
      }
    });

    const closeButtons = this.querySelectorAll('button:not(.localization-selector)');
    closeButtons.forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      // Read viewport height before open/close triggers class changes
      const viewportHeight = window.innerHeight;
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${viewportHeight}px`);
      }
    } else {
      // For submenu details elements (normal menu items, not mobile facets)
      if (!isOpen) {
        // Opening: prevent default and handle manually
        event.preventDefault();
        detailsElement.setAttribute('open', '');
        summaryElement.setAttribute('aria-expanded', true);

        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches
            ? addTrapFocus()
            : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 10);
      } else {
        // Closing: prevent default and handle manually
        event.preventDefault();
        detailsElement.removeAttribute('open');
        detailsElement.classList.remove('menu-opening');
        summaryElement.setAttribute('aria-expanded', false);
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      }
    }
  }

  _startContentObserver() {
    if (this.contentObserver || !this.nodeType) return;
    let contentTimer;
    this.contentObserver = new MutationObserver(() => {
      clearTimeout(contentTimer);
      contentTimer = setTimeout(() => {
        const currentSummaryCount = this.querySelectorAll('summary').length;
        if (currentSummaryCount > this.lastSummaryCount) {
          this.bindEvents();
        }
        this.lastSummaryCount = currentSummaryCount;
      }, 200);
    });
    this.contentObserver.observe(this, { childList: true, subtree: true });
  }

  _stopContentObserver() {
    if (this.contentObserver) {
      this.contentObserver.disconnect();
      this.contentObserver = null;
    }
  }

  openMenuDrawer(summaryElement) {
    // Activate content observer only while menu is open
    this._startContentObserver();

    // Calculate and set header position for mobile filter drawer
    if (this.classList.contains('mobile-facets__wrapper')) {
      this.calculateHeaderPosition();
      // Add resize listener to update header position
      if (!this.headerResizeHandler) {
        this.headerResizeHandler = () => this.calculateHeaderPosition();
        window.addEventListener('resize', this.headerResizeHandler);
      }
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  calculateHeaderPosition() {
    const header = document.querySelector('.section-header');
    if (header) {
      const headerWrapper = header.closest('.header-wrapper');
      const borderOffset = headerWrapper?.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      const headerBottom = parseInt(header.getBoundingClientRect().bottom - borderOffset);
      requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--header-bottom-position', `${headerBottom}px`);
      });
    } else {
      const defaultHeaderHeight = 80;
      document.documentElement.style.setProperty('--header-bottom-position', `${defaultHeaderHeight}px`);
    }
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    // Stop content observer when menu closes
    this._stopContentObserver();

    // Remove resize listener for mobile filter drawer
    if (this.classList.contains('mobile-facets__wrapper') && this.headerResizeHandler) {
      window.removeEventListener('resize', this.headerResizeHandler);
      this.headerResizeHandler = null;
    }

    // Remove open and menu-opening from all details inside menu-drawer
    this.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    // Also remove from the main details toggle
    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.classList.remove('menu-opening');
    }
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    const overlays = document.querySelectorAll('.menu-overlay, .drawer-menu-overlay');
    overlays.forEach(el => el.parentNode && el.parentNode.removeChild(el));
    // Always set aria-expanded="false" on all menu icons to remove overlay
    document.querySelectorAll('.header__icon--menu').forEach(el => el.setAttribute('aria-expanded', 'false'));
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;

    // Batch read then write to avoid forced reflow
    const headerBottom = parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset);
    requestAnimationFrame(() => {
      document.documentElement.style.setProperty('--header-bottom-position', `${headerBottom}px`);
      this.header.classList.add('menu-open');
    });

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    if (!this.header) return;
    clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => {
      // Read layout properties first
      const headerBottom = parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset);
      const viewportHeight = window.innerHeight;
      // Batch writes in rAF to avoid forced reflow
      requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--header-bottom-position', `${headerBottom}px`);
        document.documentElement.style.setProperty('--viewport-height', `${viewportHeight}px`);
      });
    }, 100);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.tryInitialize();
    if (!this.initialized) {
      if (this && this.nodeType === Node.ELEMENT_NODE) {
        this.observer = new MutationObserver(() => this.tryInitialize());
        this.observer.observe(this, { childList: true, subtree: true });
      }
    }
  }

  tryInitialize() {
    const closeButton = this.querySelector('[id^="ModalClose-"]');
    if (!closeButton) return;

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    closeButton.addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }

    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);

    this.initialized = true;
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }
  connectedCallback() {
    if (this.initialized) return;
    this.tryInitialize();
    if (!this.initialized) {
      if (this && this.nodeType === Node.ELEMENT_NODE) {
        this.observer = new MutationObserver(() => this.tryInitialize());
        this.observer.observe(this, { childList: true, subtree: true });
      }
    }
  }
  tryInitialize() {
    const button = this.querySelector('button');
    if (!button) return;
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    button.onclick = null;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
    this.initialized = true;
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.tryInitialize();
    if (!this.initialized) {
      if (this && this.nodeType === Node.ELEMENT_NODE) {
        this.observer = new MutationObserver(() => this.tryInitialize());
        this.observer.observe(this, { childList: true, subtree: true });
      }
    }
  }

  tryInitialize() {
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;

    // Remove observer after initialization
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    poster.addEventListener('click', this.loadContent.bind(this));
    this.initialized = true;
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);


/*
 * Lazy component loader
 * ---------------------
 * The heavy, page-specific custom elements (variant pickers, sliders, product
 * recommendations) were moved out of global.js into their own asset files so
 * that pages which don't use them never pay the parse/compile cost. Each module
 * is fetched on demand the first time its element appears in the DOM (on initial
 * load or via AJAX section renders / cart drawer / quick-add). When a module
 * runs it calls customElements.define(), which automatically upgrades any
 * matching elements already on the page.
 */
(function () {
  // Derive the /assets/ base URL (incl. CDN host) from global.js's own <script src>.
  const base = (_globalScriptSrc || '').replace(/global\.js(\?.*)?$/, '');

  const LAZY_MODULES = {
    'slider-component': 'component-slider.js',
    'slideshow-component': 'component-slider.js',
    'variant-selects': 'component-variant-selects.js',
    'variant-radios': 'component-variant-selects.js',
    'variant-mixed-picker': 'component-variant-selects.js',
    'product-recommendations': 'component-product-recommendations.js',
  };

  const requested = new Set();

  function loadModule(file) {
    if (requested.has(file)) return;
    requested.add(file);
    const s = document.createElement('script');
    s.src = base + file;
    s.defer = true;
    document.head.appendChild(s);
  }

  function allDefined() {
    for (const tag in LAZY_MODULES) {
      if (!customElements.get(tag)) return false;
    }
    return true;
  }

  function scan(root) {
    for (const tag in LAZY_MODULES) {
      if (customElements.get(tag) || requested.has(LAZY_MODULES[tag])) continue;
      const present =
        (root.matches && root.matches(tag)) ||
        (root.querySelector && root.querySelector(tag));
      if (present) loadModule(LAZY_MODULES[tag]);
    }
  }

  // global.js is deferred, so the initial DOM is already parsed here.
  scan(document);

  // Catch elements inserted later (AJAX section renders, cart drawer, quick-add,
  // theme editor). Stop observing once every lazy element has been defined.
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1) scan(node);
      }
    }
    if (allDefined()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();


const initLicenseKey = async () => {
    if (Shopify.designMode) {
        const shop = window.Shopify.shop
        const key = window.theme_license
        let msg = ''
        if (key.length) {
            const response = await fetch(`https://vcokorqbvivvnmhetqie.supabase.co/rest/v1/licenses?store=eq.${shop}&license=eq.${key}&apikey=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZjb2tvcnFidml2dm5taGV0cWllIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTAxNzgzMzcsImV4cCI6MjAwNTc1NDMzN30.JBgiDXN5lw8l-Yy54ZqYMXP6x7zUeD0h5rFhkcfIxIg`)

            if (!response.ok) { return }
            const data = await response.json()

            if (data.length === 0) {
                msg = `The license key you have provided for this store (${shop}) is invalid. Please add a new license key.`
            } else {
                return
            }
        } else {
            msg = `You must add your unique Theme license key in the "Theme Settings" to activate the Theme for this store (${shop}).`
        }
        document.body.insertAdjacentHTML('afterbegin', `
            <div
                class="position-fixed w-100 h-100"
                style="background: rgba(0, 0, 0, .5); backdrop-filter: blur(15px); z-index: 9999999999;">
                <div
                    class="alert alert-warning position-fixed top-50 start-50 translate-middle text-center fw-bold"
                    style="background-color: #ffc107;">
                    ${msg}
                </div>
            </div>
        `)
    }
}
initLicenseKey();

if (Shopify.designMode) {
    setTimeout(() => {
        if (window.theme_license === undefined) {
            document.documentElement.remove()
        } else if (window.theme_license.length < 28 || window.theme_license.length > 32) {
            if (!document.querySelector('.alert.alert-warning.position-fixed.top-50.start-50')) {
                document.documentElement.remove()
            }
        }
    }, 4000)
}

// Navigation menu overflow detection
function checkMenuOverflow() {
  var menu = document.querySelector('.header--top-center .mega-menu__list');
  if (!menu) return;
  var isOverflowing = menu.scrollWidth > menu.clientWidth;
  requestAnimationFrame(function() {
    menu.classList.toggle('menu-overflowing', isOverflowing);
  });
}

var _menuOverflowTimer;
window.addEventListener('DOMContentLoaded', checkMenuOverflow);
window.addEventListener('resize', function() {
  clearTimeout(_menuOverflowTimer);
  _menuOverflowTimer = setTimeout(checkMenuOverflow, 150);
});
